import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useCurrentUser } from "@/pages/auth/hooks/useAuth";
import { Loader2 } from "lucide-react";
import { ROUTES } from "@/utils/routes";

interface GuardProps {
  children?: ReactNode;
}

export function RequireSuperuser({ children }: Readonly<GuardProps>) {
  const { data: user, isLoading } = useCurrentUser();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[50vh]">
        <Loader2 className="w-8 h-8 animate-spin text-purple-600" />
      </div>
    );
  }

  if (!user?.is_superuser) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  return <>{children}</>;
}

export default RequireSuperuser;
